import { fetchRefollowQueue } from '../../../utils/marketingApi';
import { refollowQueueRequestKey } from './refollowQueuePollCore';

const inflightByKey = new Map();

export async function fetchRefollowQueueShared(scope, opts = {}, { signal } = {}) {
  const key = refollowQueueRequestKey(
    scope,
    opts.page,
    opts.pageSize,
    opts.sourceBatchId,
  );
  if (inflightByKey.has(key)) {
    return inflightByKey.get(key);
  }
  const promise = fetchRefollowQueue(scope, { ...opts, signal }).finally(() => {
    if (inflightByKey.get(key) === promise) inflightByKey.delete(key);
  });
  inflightByKey.set(key, promise);
  return promise;
}
